import styles from "./ModelListRow.module.css";
import getByteSize from "../../../utils/getByteSize";
import getTags from "../../../utils/getTags";
import {modelStatusColor} from "../../../constants";
import getUsername from "../../../utils/getUsername";
import ToolTip from "../../../compoenets/ToolTip";

export default function ModelListRow({model, keyword, onClick}) {
  const getAlias = (alias, name) => {
    if (alias == name) {
      return ""
    } else {
      return alias
    }
  }
  const checkHighlight = (str: string, keyword: string) => {
    if(!keyword)
      return str;

    const parts = str.split(new RegExp(`(${keyword})`, "gi"));
    return (
        <span>
      {parts.map((part, index) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
              <mark>{part}</mark>
          ) : (
              part
          )
      )}
    </span>
    );
  }

  return (
      <>
        <tr className={styles['table-body-row']} onClick={onClick}>
          <td className={styles['row']}><ToolTip className={styles['row']}> {checkHighlight(model.name, keyword)}</ToolTip></td>
          <td className={styles['row']}><ToolTip>{checkHighlight(getAlias(model.nameAlias,
              model.name), keyword)}</ToolTip></td>
          <td className={styles['row']}><ToolTip className={styles['row']}>{checkHighlight(model.dataset, keyword)}</ToolTip></td>
          <td className={styles['row']}>{getByteSize(model.tfModel?model.tfModel.size: 0)}</td>
          <td className={styles['row']}>{checkHighlight(getUsername(model.userMail), keyword)}</td>
          <td className={styles['row']}><ToolTip className={styles['row']}>{checkHighlight(model.description, keyword)}</ToolTip></td>
          <td className={styles['row-tag']}><ToolTip message={getTags(model.userTags, model.autoTags, 1000)}>{checkHighlight(getTags(model.userTags,
              model.autoTags, 3, keyword), keyword)}</ToolTip></td>
          <td className={styles['row']}>
            <div className={styles['row-status-wrap']}>
              <div className={styles['status-body']}>
                <div className={styles['status-dot']}
                     style={{background: modelStatusColor["0"]}}></div>
              </div>
            </div>
          </td>
        </tr>
      </>
  )
}